import React from 'react';
import PropTypes from 'prop-types';
import {DiamondIcon} from '~library/svg/DiamondIcon';
import {roseWebText} from '~libSass/base/_exports.sass';
import {CheckmarkIcon} from '~library/svg/CheckmarkIcon';
import {Button} from '~library/atoms/Button';
import {InformationCircleIcon} from '~library/svg/InformationCircleIcon';

export const Filter = (props) => {
  const {
    filterSectionName,
    filterId,
    attributes,
    id,
    isColorFilter,
    filterName,
    onPremiumInfoClick,
  } = props;
  if (!id) return null;

  return (
    <li
      className={`gallery__filter-item gallery__filter-color-selected gallery__filter-item-${id} ${
        !attributes.enabled ? 'disabled' : ''
      } ${isColorFilter ? 'gallery__color-filter-wrapper' : ''}`}
      onClick={
        attributes.enabled
          ? (e) => {
              e.preventDefault();
              e.stopPropagation();
              props.onToggle(filterSectionName, filterId, !attributes.on);
            }
          : undefined
      }
      data-qa-id={`gallery-filter_${filterName}`}
    >
      <input
        className={`gallery__filter-input checkbox ${!attributes.enabled ? 'disabled' : ''} ${
          isColorFilter ? `color-filter  color-${filterName}` : ''
        }`}
        disabled={!attributes.enabled}
        type="checkbox"
        name="filter"
        id={`id_type_${filterName}`}
        value={`${filterName}`}
        data-qa-id={`gallery-filter-input_${filterName}`}
        checked={attributes.on}
        data-checked={attributes.on}
        readOnly
      />
      {isColorFilter && !attributes.enabled && (
        <div className={`gallery__filter--color-label--cross-out ${filterName}`} />
      )}
      {isColorFilter && attributes.on && (
        <CheckmarkIcon
          className={`gallery__filter--color-label--selected ${filterName}`}
          ratio={0.5}
          color={filterName === 'white' ? 'black' : 'white'}
        />
      )}
      {filterName.toLowerCase() === 'premium' && (
        <DiamondIcon color={roseWebText} className="gallery__filter--premium-icon" />
      )}
      {!isColorFilter && (
        <label
          className={`gallery__filter-label ${
            isColorFilter ? `gallery__filter--color-label color-${filterName}` : ''
          } ${attributes.on ? 'on' : 'off'} ${!attributes.enabled ? 'disabled' : ''}`}
          htmlFor={`id_type_${filterName}`}
        >
          {filterName}
        </label>
      )}
      {filterName.toLowerCase() === 'premium' && (
        <Button
          variant="transparent"
          onClick={onPremiumInfoClick}
          data-qa-id="premium-filter-info"
          className="gallery__filter--premium-info"
        >
          <InformationCircleIcon ratio={0.5} color={roseWebText} />
        </Button>
      )}
    </li>
  );
};

Filter.propTypes = {
  id: PropTypes.string.isRequired,
  onToggle: PropTypes.func,
  filterSectionName: PropTypes.string,
  filterId: PropTypes.string,
  filterName: PropTypes.string,
  attributes: PropTypes.object,
  isColorFilter: PropTypes.bool,
  onPremiumInfoClick: PropTypes.func,
  // 'data-qa-id': PropTypes.string.isRequired,
};
